import { useContext } from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import moment from 'moment';
import { doubleSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { RootState } from 'redux/schemas';
import AiConversationContext from './context';
import CompleteStatus from './complete-status';
import { ClosingReason } from './stream-ai-response';
import useAiRolePlayHelper from '../hooks/use-ai-role-play-helper';

const CompletionSection = () => {
  const { sessionData } = useContext(AiConversationContext);
  const { isTabletOrSmaller } = useAiRolePlayHelper();

  const submission = useSelector((state: RootState) => (
    sessionData.submissionId
      ? state.models.aiRolePlaySubmissions[sessionData.submissionId]
      : null
  ));

  const isBodyPartitioned = !isTabletOrSmaller
    && submission?.closingReason === ClosingReason.COMPLETED;

  const styles = css`
    margin-top: auto !important;
    .complete-status-container {
      margin-bottom: ${isBodyPartitioned ? standardSpacing : doubleSpacing}px;
    }
  `;

  const getTimestamp = () => {
    switch (submission?.closingReason) {
      case ClosingReason.TERMINATED:
        return t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.SESSION_ENDED_ON(moment(submission.finishedAt).format('LLL'));
      case ClosingReason.COMPLETED:
        return t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.COMPLETED_ON(moment(submission.finishedAt).format('LLL'));
      default:
        return null;
    }
  };

  return (
    <div css={styles} className='d-flex flex-column'>
      {submission?.finishedAt && (
        <p className='mt-5 font-weight-normal'>{getTimestamp()}</p>
      )}
      <div className='complete-status-container mt-auto pt-4'>
        <CompleteStatus />
      </div>
    </div>
  );
};

export default CompletionSection;
